import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { QUERY_KEYS, HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useWalletCreditsV2 = (params, options = {}) => {
  return useQuery(
    [QUERY_KEYS.walletCreditsV2, params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getWalletCreditsV2(), {
        params,
      });

      const composeResponse = {
        clinics: Object.values(res.data.data.filters.clinics || {}),
        clinicWalletCredits: res.data.data.report.clinic_report,
        providerWalletCredits: res.data.data.report.provider_report,
      };
      return composeResponse;
    },
    options,
  );
};
